export const ROUTES = {
	"lux-ai": "LuxStudio",
	projector: "Projectors",
	schedule: "Schedule",
	"show-library": "My Shows",
	"media-library": "My Media",
}

export const NEW_ROUTES: Array<keyof typeof ROUTES> = ["lux-ai"]

export const NEXT_ROUTE_KEY = "next"
